import { Component, OnInit } from '@angular/core';
import { AlertService, JhiLanguageService } from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { AdmisService } from './admis.service';
import { PieceJointeService } from '../piece-jointe';
import { Response } from '@angular/http';
import { JhiAlertComponent } from '../../shared';
import {CALENDAR_FR} from "../../shared/calendar/calendar.constants";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import { Candidature, CandidatureFormation, CandidatureFormationService, CandidatureService } from '../candidature';
import {forkJoin} from "rxjs/observable/forkJoin";
import {DateFormatter} from "@angular/common/src/pipes/intl";

@Component({
    selector: 'jhi-faq',
    templateUrl: './admis.component.html'
})
export class AdmisComponent implements OnInit {

    fr = CALENDAR_FR;
    isLoading = false;
    candidature: Candidature;
    candidatureFormation: CandidatureFormation;
    piecesIdentite: any[];
    form: FormGroup;
    conformites = [
        { label: 'Conforme', value: true },
        { label: '-', value: null },
        { label: 'Non conforme', value: false },
    ];

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private activatedRoute: ActivatedRoute,
        private alertService: AlertService,
        private translate: TranslateService,
        private admisService: AdmisService,
        private formBuilder: FormBuilder,
        private pieceJointeService: PieceJointeService,
        private candidatureService: CandidatureService,
        private candidatureFormationService: CandidatureFormationService,
        private router: Router
    ) {
        this.jhiLanguageService.setLocations(['global', 'admis', 'candidature']);
        this.form = this.formBuilder.group({
            candidatureFormationId: new FormControl({disabled: true}, Validators.required),
            commission: new FormControl({disabled: true}, Validators.required),
            civilite: new FormControl({}, Validators.required),
            nom: new FormControl({}, Validators.required),
            nomUsuel: new FormControl(),
            prenom: new FormControl({}, Validators.required),
            prenom2: new FormControl(),
            dateNaissance: new FormControl({}, Validators.required),
            controleIdentiteAdmis: new FormControl()
        });
    }

    ngOnInit() {
        this.initCandidatureEtFormulaire();
    }

    private initCandidatureEtFormulaire() {
        this.isLoading = true;
        const candidatureFormation = this.admisService.getCurrentCandidature();
        if (candidatureFormation && candidatureFormation.id) {
            const candidatureQuery = this.candidatureService.find(candidatureFormation.candidatureId);
            const candidatureFormationQuery = this.candidatureFormationService.find(candidatureFormation.id, false);
            const pieceJointeQuery = this.pieceJointeService.findPieceIdentite(candidatureFormation.id);
            forkJoin(candidatureQuery, candidatureFormationQuery, pieceJointeQuery).subscribe(res => {
                this.candidature = res[0];
                this.candidatureFormation = res[1];
                this.initFormWithCandidatureData();
                this.piecesIdentite = res[2].json();
                if (this.piecesIdentite) {
                    this.piecesIdentite.forEach(piece => {
                        this.pieceJointeService.openFile(piece.nom).subscribe((res) => {
                                this.pieceJointeService.initPDFOrImageFile(res, piece);
                                this.isLoading = false;
                            },
                            error => {
                                this.isLoading = false;
                                this.onError(error);
                            });
                    });
                }
            });
        } else {
            this.isLoading = false;
        }
    }

    private initFormWithCandidatureData() {
        this.form.get('candidatureFormationId').setValue(this.candidatureFormation.id);
        this.form.get('commission').setValue(this.candidatureFormation.commission);
        this.form.get('nom').setValue(this.candidature.nomPatronymique);
        this.form.get('civilite').setValue(this.candidature.civilite);
        this.form.get('nomUsuel').setValue(this.candidature.nomUsuel);
        this.form.get('prenom').setValue(this.candidature.prenom);
        this.form.get('prenom2').setValue(this.candidature.prenom2);
        this.form.get('dateNaissance').setValue(DateFormatter.format(this.candidature.dateNaissance, 'fr', 'dd/MM/yyyy'));
        this.form.get('controleIdentiteAdmis').setValue(this.candidatureFormation.controleIdentiteAdmis);
    }

    private initCandidatureDataWithForm() {
        this.candidature.nomPatronymique = this.form.get('nom').value;
        this.candidature.civilite = this.form.get('civilite').value;
        this.candidature.nomUsuel = this.form.get('nomUsuel').value;
        this.candidature.prenom = this.form.get('prenom').value;
        this.candidature.prenom2 = this.form.get('prenom2').value;
        if(typeof this.form.get('dateNaissance').value !== 'string') {
            this.candidature.dateNaissance = this.form.get('dateNaissance').value;
        }
        this.candidatureFormation.controleIdentiteAdmis = this.form.get('controleIdentiteAdmis').value;
    }

    onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    onSubmit() {
        this.isLoading = true;
        this.initCandidatureDataWithForm();
        const updates = [
            this.candidatureService.update(this.candidature),
            this.candidatureFormationService.update(this.candidatureFormation, false, false)
        ];
        forkJoin(updates).subscribe(
            () => this.isLoading = false,
            error => {
                this.isLoading = false;
                this.onError(error);
            }
        );
    }

    dossierPrecedent() {
        this.admisService.previous();
        this.initCandidatureEtFormulaire();
    }

    dossierSuivant() {
        this.admisService.next();
        this.initCandidatureEtFormulaire();
    }

    retour() {
        this.router.navigate(['/candidature']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/admis/admis.component.ts